export interface ISortableMessages {
  id: number;
  created: Date;
  createdTimestamp: number;
  message?: IMessageData;
  systemMessage?: ISystemMessageData;
  sent: boolean;
}

export default interface IMessageData {
  id: number;
  authorId: number;
  created: Date;
  createdTimestamp?: number;
  jobId: number;
  jobAssignmentId?: number;
  text: string;
  readBy: number[];
  sending?: boolean;
  sent?: boolean;
}

export enum SystemMessageType {
  WORKER_INTERESTED_IN_JOB = 'WORKER_INTERESTED_IN_JOB',
  WORKER_UNAPPLIES = 'WORKER_UNAPPLIES',
  WORKER_ACCEPTS_JOB = 'WORKER_ACCEPTS_JOB',
  WORKER_DECLINES_JOB = 'WORKER_DECLINES_JOB',
  COMPANY_OFFERS_JOB = 'COMPANY_OFFERS_JOB',
  COMPANY_REOFFERS_JOB = 'COMPANY_REOFFERS_JOB',
  COMPANY_HIRED_WORKER = 'COMPANY_HIRED_WORKER',
  COMPANY_UPDATED_SUBMITTED_TIME = 'COMPANY_UPDATED_SUBMITTED_TIME',
  COMPANY_ADDED_TIMESHEET = 'COMPANY_ADDED_TIMESHEET',
}

export interface ISystemMessageData {
  id: number;
  created: Date;
  type: SystemMessageType | string;
  eventText: string;
  text?: string;
}

export interface ISystemMessageCombined
  extends Omit<ISystemMessageData, 'type'> {
  systemType: SystemMessageType | string;
}

/**
 * CombinedMessage is for job messages since it can include system messages
 * system messages are messages from the app and not from the users that
 * has to be present in the chat body.
 * example: job offered, job accepted, etc
 */
export type CombinedMessage =
  | (IMessageData & { type: 'message' })
  | (ISystemMessageCombined & { type: 'system' });
